import { Component } from '@angular/core';
import { EntitySelectorComponent } from '@app/selection/entity-selector.component';
import { User } from '@app/_models/_DTOs/user';
import { UserService } from '@app/_services/user.service';

@Component({
    selector: 'app-users-selector',
    templateUrl: './users-selector.component.html',
    styleUrls: ['./users-selector.component.css']
})
export class UsersSelectorComponent extends EntitySelectorComponent<User> {

    sorts = "LastName";
    filters = "";

    constructor(
        private userService: UserService
    ) {
        super(userService);
    }
}